import { gate } from 'hub-http/gates';
export const SubscriptionGroups = 'subscriptions:groupSettings';
export const Pagination = 'Forms:Pagination';
export const CampaignBusinessUnit = 'campaign-business-unit';
export const SubmissionsExportName = 'Submissions:ExportName';
export const LimitedTicketFunctionInInbox = 'HelpDesk:LimitedTicketFunctionInInbox';
export const RemoveATCFromForms = 'HelpDesk:LimitedTicketFunctionInInbox:RemoveATCFromForms';
export const OverridePaymentPermissions = 'Forms:OverridePaymentPermissions';
export const BusinessUnitUsers = 'business-units:business-unit-users';
export const ShareEmbedV3 = 'Forms:ShareEmbedV3';
export const NewEditorAccess = 'Forms:NewEditorAccess';

//#forms-ccp, potential rollout planned in 2024 Q3
export const AdConsentProperties = 'Forms:AdConsentProperties';
export const BusinessUnitPicker = 'navigation:businessUnitPicker';
export const DataEnrichmentBeta = gate('DataEnrichment:PublicBeta');
export const CopilotCreateForm = gate('VisExpEditor:CopilotCreateForm');
export const AgenticRelease = gate('SetupCrm:AgenticRelease');
export const FormAnalyzeTabPhase2 = gate('MRFE:FormsAnalyzeTab');
export const LimitedAccessLegacyForms = gate('LeadCapture:LimitAccessLegacyForms');
export const SpamSubmissionsCodeOrange = gate('LeadCaptureFE:SpamSubmissionUpdates');